import {sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {
    blockEmployeeFx,
    employees$,
    fetchEmployeesFx,
    fetchThemesFx,
    Gate,
    themes$,
    unblockEmployeeFx,
} from './index';

employees$.on(fetchEmployeesFx.doneData, (_, employees) => employees).reset(Gate.close);
employees$
    .on(blockEmployeeFx.done, (employees, {params}) =>
        employees.map((employee) =>
            employee.userId === params.id ? {...employee, isBlocked: true} : employee,
        ),
    )
    .on(unblockEmployeeFx.done, (employees, {params}) =>
        employees.map((employee) =>
            employee.userId === params.id ? {...employee, isBlocked: false} : employee,
        ),
    );
themes$.on(fetchThemesFx.doneData, (_, themes) => themes).reset(Gate.close);

sample({clock: Gate.open, target: [fetchEmployeesFx, fetchThemesFx]});

[fetchEmployeesFx, fetchThemesFx, blockEmployeeFx, unblockEmployeeFx].forEach((effect) =>
    effect.failData.watch((error) => showRestError(error as RestError)),
);
